import { registerTermUIElement, type HtmlAction } from "../src";

registerTermUIElement();

type DemoTermElement = HTMLElement & {
  render: () => void;
};

const term = document.querySelector<DemoTermElement>("#interactive-term");
const status = document.querySelector<HTMLDivElement>("#interactive-status");

if (!term || !status) {
  throw new Error("Missing docs interactive nodes");
}

let count = 0;
let mode: "dark" | "light" = "dark";

function describe(action: HtmlAction): string {
  if (action.type === "link") return `link:${action.href ?? action.text}`;
  return `action:${action.id ?? action.text}`;
}

function interactiveHtml(counter: number): string {
  return `
<section gap="1">
  <article title="runtime controls">
    <p>counter ${counter}</p>
    <nav gap="1">
      <button action="inc">+1</button>
      <button action="dec">-1</button>
      <button action="reset">reset</button>
      <button action="toggle-mode">toggle mode</button>
    </nav>
  </article>
  <footer left=" docs interactive " right=" plain js "></footer>
</section>
  `.trim();
}

function render(): void {
  term.setAttribute("mode", mode);
  term.setAttribute("source", interactiveHtml(count));
  term.render();
}

term.addEventListener("termui-action", (event) => {
  const action = (event as CustomEvent<HtmlAction>).detail;
  if (action.type !== "action") {
    status.innerHTML = `Last event: <strong>${describe(action)}</strong>`;
    return;
  }

  switch (action.id) {
    case "inc":
      count += 1;
      break;
    case "dec":
      count -= 1;
      break;
    case "reset":
      count = 0;
      break;
    case "toggle-mode":
      mode = mode === "dark" ? "light" : "dark";
      break;
    default:
      break;
  }

  render();
  status.innerHTML = `Last event: <strong>${describe(action)}</strong>`;
});

render();
